"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var node_crypto_1 = require("node:crypto");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return node_crypto_1.randomFillSync; } });
